import defaultPostTypeConfig from '../post'
import capitalize from '../../utils/capitalize'

export default function getConstants(p = {}) {

    const name = 'softSkill'

    const n = name
    const N = capitalize(n)
    const ns = (name.endsWith('y')) ? name.slice(0, -1) + 'ies' : name + 's'
    const Ns = capitalize(ns)

    const {
        labels,
        menus,
        messages,
        routes,
        titles
    } = defaultPostTypeConfig.getConstants({
        ...p,
        name
    })

    return {
        labels: {
            ...labels,
            ['new' + N + 'SubmitLabel']: 'Mentés',
            ['restore' + N + 'SubmitLabel']: 'Visszaállítás',
            ['save' + N + 'SubmitLabel']: 'Mentés',
            ['cancel' + N + 'Text']: 'Mégsem',
            ['delete' + N + 'Text']: 'Törlés',
            ['delete' + Ns + 'Text']: 'Tulajdonságok törlése',
            ['ban' + N + 'Text']: 'Tiltás',
            ['approve' + N + 'Text']: 'Jóváhagyás',
            ['protection' + N + 'Text']: 'Védettnek jelölés',
            ['removeProtection' + N + 'Text']: 'Védettség megszüntetése',
            ['select' + N + 'Text']: 'Kiválasztás',
            ['add' + N + 'Text']: 'Hozzáadás',
            ['date' + N + 'Format']: ({ dateText = '' }) => {
                if (!dateText) {
                    return dateText
                }
                try {
                    return new Date(dateText).toLocaleString('hu-HU')
                } catch (e) {
                }
                return dateText
            },
            [ns + 'SortRelevance']: 'Relevancia',
            [ns + 'More']: 'Továbbiak'
        },
        menus: {
            ...menus,
            ['user' + Ns + 'Menu']: 'Tulajdonságok',
            ['my' + Ns + 'Menu']: 'Tulajdonságaim',
            ['new' + N + 'Menu']: 'Új tulajdonság',
            [ns + 'Menu']: 'Tulajdonságok',
            ['deleted' + Ns + 'Menu']: 'Törölt tulajdonságok',
            ['banned' + Ns + 'Menu']: 'Véglegesen törölt tulajdonságok',
            ['protection' + Ns + 'Menu']: 'Védett tulajdonságok',
            ['missingData' + Ns + 'Menu']: 'Hiányzó adatok',
            ['lowAuthorStatus' + Ns + 'Menu']: 'Szerző alacsony státusszal',

            ['edit' + N + 'Menu']: 'Szerkesztés',
            ['delete' + N + 'Menu']: 'Törlés',
            ['ban' + N + 'Menu']: 'Tiltás',
            ['approve' + N + 'Menu']: 'Jóváhagyás',
            ['protection' + N + 'Menu']: 'Védettnek jelölés',
            ['removeProtection' + N + 'Menu']: 'Védettség törlése'
        },
        messages: {
            ...messages,
            ['new' + N + 'SuccessMessage']: 'Az új tulajdonság mentésre került',
            ['save' + N + 'SuccessMessage']: 'A tulajdonság mentésre került',
            ['delete' + N + 'Success']: 'A tulajdonság törölve lett',
            ['delete' + Ns + 'Success']: 'A tulajdonságok törölve lettek',
            ['delete' + N + 'Question']: 'Biztosan törli a tulajdonságot?',
            ['delete' + Ns + 'Question']: 'Biztosan törli a tulajdonságokat?',
            ['ban' + N + 'Success']: 'A tulajdonság véglegesen törölve lett',
            ['ban' + N + 'Question']: 'Biztos, hogy a tulajdonságot véglegesen törölni akarod?',
            ['approve' + N + 'Success']: 'A tulajdonság jóvá lett hagyva',
            ['approve' + N + 'Question']: 'Biztosan jóváhagyod a tulajdonságot',
            ['protection' + N + 'Success']: 'A tulajdonság védettnek jelölve',
            ['protection' + N + 'Question']: 'Biztosan védettnek jelölöd a tulajdonságot?',
            ['removeProtection' + N + 'Success']: 'A védettnek jelölés törölve lett',
            ['removeProtection' + N + 'Question']: 'Biztosan törlöd a védettnek jelölést?',
            ['thereAreNo' + Ns]: 'Nincsenek tulajdonságok'
        },
        routes: {
            ...routes
        },
        titles: {
            ...titles,
            [n + 'Title']: 'Tulajdonság',
            [ns + 'Title']: 'Tulajdonságok',
            ['new' + N + 'Title']: 'Új tulajdonság',
            ['edit' + N + 'Title']: 'Tulajdonság szerkesztése',
            ['user' + Ns + 'Title']: 'Tulajdonságok',
            ['userDeleted' + Ns + 'Title']: 'Törölt tulajdonságok',
            ['my' + Ns + 'Title']: 'Tulajdonságaim',
            ['myDeleted' + Ns + 'Title']: 'Törölt tulajdonságaim',

            ['dialogDelete' + N + 'Title']: 'Tulajdonság törlése',
            ['dialogBan' + N + 'Title']: 'Tulajdonság törlése véglegesen',
            ['dialogApprove' + N + 'Title']: 'Tulajdonság jóváhagyása',
            ['dialogProtection' + N + 'Title']: 'Tulajdonság védettnek jelölése',
            ['dialogRemoveProtection' + N + 'Title']: 'Tulajdonság védettségének megszüntetése',

            ['dialogDelete' + Ns + 'Title']: 'Tulajdonságok törlése',

            ['statusBanned' + N + 'Title']: 'Véglegesen törölt',
            ['statusDeleted' + N + 'Title']: 'Törölt',
            ['statusAuthorDeleted' + N + 'Title']: 'Szerző törölve',
            ['statusMissingData' + N + 'Title']: 'Hiányzó adatok',
            ['statusApproved' + N + 'Title']: 'Jóváhagyott',
            ['statusFeatured' + N + 'Title']: 'Védett',
            ['statusCreated' + N + 'Title']: 'Létrehozva',

            ['banned' + Ns + 'Title']: 'Véglegesen törölt tulajdonságok',
            ['deleted' + Ns + 'Title']: 'Törölt tulajdonságok',
            ['missingData' + Ns + 'Title']: 'Hiányzó adatok',
            ['protected' + Ns + 'Title']: 'Védett tulajdonságok',
            ['lowAuthorStatus' + Ns + 'Title']: 'Szerző alacsony státusszal',

            ['select' + Ns]: 'Tulajdonságok kiválasztása',
            ['select' + N]: 'Tulajdonság kiválasztása'
        }
    }
}
